import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import { NotificationProvider } from "../../context/NotificationContext";

const Layout: React.FC = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  // Add media query to automatically collapse sidebar on small screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSidebarOpen(false);
      }
    };

    // Set initial state based on screen size
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Toggle Sidebar Visibility
  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  return (
    <NotificationProvider>
      {" "}
      <div className="h-screen flex flex-col">
        {/* ✅ Fixed Navbar */}
        <header style={{ zIndex: 40 }} className="fixed top-0 left-0 right-0">
          <Navbar toggleSidebar={toggleSidebar} />
        </header>

        <div className="flex flex-1 pt-16">
          {/* ✅ Sidebar wrapper - zero width but contains the fixed sidebar */}
          <div className="relative">
            <Sidebar
              isExpanded={isSidebarOpen}
              setIsExpanded={setSidebarOpen}
            />
          </div>

          {/* ✅ Main Content - Adjusts based on sidebar state */}
          <main
            className={`flex-1 bg-white p-6 overflow-auto transition-all duration-300
            ${isSidebarOpen ? "md:ml-72" : "md:ml-20"}`}
          >
            <Outlet />
          </main>
        </div>
      </div>
    </NotificationProvider>
  );
};

export default Layout;
